document.addEventListener("DOMContentLoaded", () => {
  var popularSlider = new Swiper("#about-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    grabCursor: true,
    pagination: {
      el: ".about-box__control .control__pagination",
      type: "fraction",
    },
    lazy: {
      loadPrevNext: true,
      checkInView: true,
    },
    navigation: {
      nextEl: ".about-box__control .control__arrow--next",
      prevEl: ".about-box__control .control__arrow--prev",
    },
  });
});
